var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLushaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#0755ff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613 1106 c-72 -23 -132 -85 -150 -155 -6 -24 -23 -43 -63 -69 -65 -44 -119 -112 -146 -185 -40 -108 -20 -336 42 -472 l22 -50 2 50 c1 28 4 68 8 90 l8 40 19 -39 c28 -56 65 -80 123 -80 84 0 151 73 139 150 -5 32 -4 34 21 34 25 0 27 -3 28 -48 1 -63 30 -105 88 -127 35 -13 51 -14 83 -6 55 15 103 71 103 122 0 32 13 14 26 -34 l10 -42 19 80 c14 55 20 117 20 200 0 109 -2 125 -27 177 -14 31 -38 64 -52 73 -23 15 -26 24 -26 71 0 92 -43 164 -121 204 -50 26 -125 33 -176 16z m141 -444 c3 -21 19 -64 34 -95 l29 -57 -33 0 c-23 0 -44 -10 -67 -30 -46 -40 -110 -42 -146 -5 -28 30 -57 38 -110 33 -39 -3 -39 -3 -23 16 37 41 264 175 298 176 6 0 14 -17 18 -38z m-223 -202 c10 -6 26 -25 35 -42 34 -66 -12 -143 -88 -143 -53 0 -98 47 -98 101 0 70 86 118 151 84z m340 -19 c68 -68 3 -187 -91 -166 -49 11 -88 73 -75 122 18 73 112 98 166 44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLushaIcon);
export default __webpack_public_path__ + "static/media/lusha-icon.8c71c32ae25decd1b2d00fa57b3e0de0.svg";
export { ForwardRef as ReactComponent };